import { useApiQuery } from "app/modules/api-client";
import DurationService from "app/services/DurationService";

import { useAdvertiserActivityDataAndParams } from "../../common/hooks/useAdvertiserActivityDataAndParams";

export const usePerformanceOverTime = () => {
    const params = useAdvertiserActivityDataAndParams();
    const { from, to } = DurationService.getDurationData(params.duration ?? "").forAPI;

    return useApiQuery(
        {
            tag: "AdIntelligenceOverview",
            methodName: "adIntelligenceAdvertiserUnifiedChannelMetricsPerformanceOverTimeList",
        },
        {
            country: params.country,
            key: params.key?.split(",") ?? [],
            from,
            to,
        },
    );
};
